import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import UseHelp from '@/components/UseHelp'
import News from '@/components/News'
import NewsDetails from '@/components/NewsDetails'
import Down from '@/components/Down'
import About from '@/components/About'
import Privacy from '@/components/Privacy'
import Regester from '@/components/Regester'
import JoinUs from '@/components/JoinUs'
import res from '@/components/res'
// App页面
import AppNewsDetails from '@/components/app/AppNewsDetails'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/Home'
    },
    {
      path: '/Home',
      component: Home
    },
    {
      path: '/UseHelp',
      component: UseHelp
    },
    {
      path: '/News',
      component: News
    },
    {
      path: '/NewsDetails',
      component: NewsDetails
    },
    {
      path: '/Down',
      component: Down
    },
    {
      path: '/About',
      component: About
    },
    {
      path: '/AppNewsDetails',
      component: AppNewsDetails
    },
    {
      path: '/Privacy',
      component: Privacy
    },
    {
      path: '/Regester',
      component: Regester
    },
    {
      path: '/JoinUs',
      component: JoinUs
    },
    {
      path: '/res',
      component: res
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js